import script from "./owner-team.vue?vue&type=script&setup=true&lang=js"
export * from "./owner-team.vue?vue&type=script&setup=true&lang=js"

import "./owner-team.vue?vue&type=style&index=0&id=593e0489&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-593e0489"]])

export default __exports__